import React, { Component } from "react";
import styles from "./SlideCompositionPage.local.scss";
import {
  setSideBar,
  setSelectedComponent,
  setSelectedCase,
  initComponentAction
} from "Actions";
import classnames from "classnames";
import _ from "i18n";
import { connect } from "react-redux";

class ComponentList extends Component {
  constructor(props) {
    super(props);

    this.state = { expandedIndex: ["STANDARD"] };
  }
  handleChangeSideBar = (sideBar, selectedComponent, ComponentType) => {
    const { dispatch } = this.props;
    dispatch(setSideBar(sideBar));
    dispatch(initComponentAction());
    this.handleChangeSelectedComponent(selectedComponent);
    this.props.HandleChangeComponentType(ComponentType);
  };

  handleToggleComponent = index => {
    const { expandedIndex } = this.state;
    if (expandedIndex.some(t => t === index)) {
      this.setState({
        expandedIndex: expandedIndex.filter(t => t !== index)
      });
    } else {
      this.setState({
        expandedIndex: [...expandedIndex, index]
      });
    }
  };
  handleChangeSelectedComponent = selectedComponent => {
    const { dispatch } = this.props;
    dispatch(setSelectedComponent(selectedComponent));
  };
  render() {
    const { expandedIndex } = this.state;
    return (
      <div>
        {/*<div*/}
        {/*  style={{ marginLeft: "30px", marginTop: "10px" }}*/}
        {/*  onClick={() => this.handleChangeSideBar("slideConfiguration", "", "")}*/}
        {/*>*/}
        {/*  <img*/}
        {/*    src={"/img/icons/back.svg"}*/}
        {/*    alt=""*/}
        {/*    className={styles.button_back}*/}
        {/*  />*/}
        {/*</div>*/}
        <div
          className={styles.slides_type_collapse_header}
          onClick={() => {
            this.handleChangeSideBar("slideConfiguration", "", "");
            this.props.dispatch(setSelectedCase(""));
          }}
        >
          <img
            src={"/img/icons/back_arrow_clear_blue.svg"}
            alt={""}
            className={classnames(styles.button_back)}
          />
          {_("Retour au configuration")}
        </div>
        {/*     component type header    */}
        <div
          className={styles.slides_type_collapse_header}
          onClick={() => this.handleToggleComponent("STANDARD")}
        >
          {_("componentsList")}
          <img
            src={"/img/icons/dropdown_small_two_arrow.svg"}
            alt={""}
            className={classnames(
              styles.icon,
              expandedIndex.some(t => t === "STANDARD")
                ? styles.expanded
                : styles.collapsed
            )}
          />
        </div>
        {/*      component list      */}
        <div
          className={classnames(
            styles.component_list,
            expandedIndex.some(t => t === "STANDARD")
              ? styles.component_expanded
              : styles.component_collapsed
          )}
        >
          <div className={`row`}>
            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "MultiIndicatorComponentConfig",
                  "BarChartComponent.png",
                  "BAR_CHART_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/BarChartComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "MultiIndicatorComponentConfig",
                  "LineChartComponent.png",
                  "LINE_CHART_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/LineChartComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "ComponentConfig",
                  "TrafficLightAndValuesComponent.png",
                  "TRAFFIC_LIGHT_AND_VALUES_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/TrafficLightAndValuesComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "ComponentConfig",
                  "SimpleValueAndTinyChartComponent.png",
                  "SIMPLE_VALUE_AND_TINY_CHART_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/SimpleValueAndTinyChartComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "ComponentConfig",
                  "ValueDescAndBarChartComponent.png",
                  "VALUE_DESC_AND_BAR_CHART_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/ValueDescAndBarChartComponent.png`}
                alt={""}
                width={"300px"}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "NumberOfYearsComponentConfig",
                  "BalanceSheetComponent.png",
                  "BALANCE_SHEET_COMPONENT"
                )
              }
            >
              <img
                width={"300px"}
                src={`/img/slide-composition/component-image/BalanceSheetComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "NumberOfYearsComponentConfig",
                  "TableComponent.png",
                  "TABLE_COMPONENT"
                )
              }
            >
              <img
                width={"300px"}
                src={`/img/slide-composition/component-image/TableComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "MultiIndicatorComponentConfig",
                  "IllustrativeProgressBarsComponent.png",
                  "ILLUSTRATIVE_PROGRESS_BARS_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/IllustrativeProgressBarsComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>
            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "ComponentConfig",
                  "SimpleValueAndIconComponent.png",
                  "SIMPLE_VALUE_AND_ICON_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/SimpleValueAndIconComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "BarometerConfig",
                  "BarometerAndValueComponent.png",
                  "BAROMETER_AND_VALUE_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/BarometerAndValueComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>
            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "ComponentConfig",
                  "IllustrativeIconAndValueComponent.png",
                  "ILLUSTRATIVE_ICON_AND_VALUE_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/IllustrativeIconAndValueComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>

            <div
              className={`large-12 medium-12 small-12`}
              onClick={() =>
                this.handleChangeSideBar(
                  "MultiIndicatorComponentConfig",
                  "ValueDeskAndPieChartComponent.png",
                  "VALUE_DESK_AND_PIE_CHART_COMPONENT"
                )
              }
            >
              <img
                src={`/img/slide-composition/component-image/ValueDeskAndPieChartComponent.png`}
                alt={""}
                className={styles.component}
              />
            </div>
            {/*<div*/}
            {/*  className={`large-12 medium-12 small-12`}*/}
            {/*  onClick={() =>*/}
            {/*    this.handleChangeSideBar("ComponentConfig", "image 19", "")*/}
            {/*  }*/}
            {/*>*/}
            {/*  <img*/}
            {/*    src={`/img/slide-composition/component-image/SimpleValueAndIconComponent.svg`}*/}
            {/*    alt={""}*/}
            {/*    className={styles.component}*/}
            {/*  />*/}
            {/*</div>*/}

            {/*<div*/}
            {/*  className={`large-12 medium-12 small-12`}*/}
            {/*  onClick={() =>*/}
            {/*    this.handleChangeSideBar("ComponentConfig", "image 12", "")*/}
            {/*  }*/}
            {/*>*/}
            {/*  <img*/}
            {/*    width={"300px"}*/}
            {/*    src={`/img/slide-composition/component-image/IllustrativeIconAndValueComponent.svg`}*/}
            {/*    alt={""}*/}
            {/*    className={styles.component}*/}
            {/*  />*/}
            {/*</div>*/}

            {/*<div*/}
            {/*  className={`large-12 medium-12 small-12`}*/}
            {/*  onClick={() =>*/}
            {/*    this.handleChangeSideBar(*/}
            {/*      "MultiIndicatorComponentConfig",*/}
            {/*      "IllustrativeProgressBarsComponent",*/}
            {/*      "ILLUSTRATIVE_ICON_AND_VALUE_COMPONENT"*/}
            {/*    )*/}
            {/*  }*/}
            {/*>*/}
            {/*  <img*/}
            {/*    width={"300px"}*/}
            {/*    src={`/img/slide-composition/component-image/IllustrativeProgressBarsComponent.svg`}*/}
            {/*    alt={""}*/}
            {/*    className={styles.component}*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

export default connect(mapStateToProps)(ComponentList);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/ComponentList.js